import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box, Stack } from "@mui/material";
import { toastWarn } from "../../../common/Toast";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const OpenInvoices = (props) => {
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [totalOpenBalance, setTotalOpenBalane] = useState(0);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(3);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [custoptions, setCustOptions] = useState([]);
  const [customerID, setCustomerID] = useState([]);
  const [agingMethod, setAgingMethod] = useState("Current");
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(location)
  );
  const [nemultiselect, setnemultiselect] = useState({
    TransactionType: [],
  });

  const [classicView, setClassicView] = useState(true);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleNavigation = (Id, Type) => {
    console.log(Id, Type, "checkIdType");
    if (Type === "Invoice" || Type === "Credit Memo") {
      window.open(`/sales-receipt/${Id}`, "_blank");
    } else if (Type === "Payment") {
      window.open(`/receive-payment/${Id}`, "_blank");
    } else if (Type === "Journal Entry") {
      window.open(`/journal-entry/${Id}`, "_blank");
    } else if (Type === "Deposit") {
      window.open(`/bank-deposit/${Id}`, "_blank");
    } else {
      window.open(`/Expense/${Id}`, "_blank");
    }
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/openinvoicereport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${selectedlocationid}&currentlocationid=${location}&customerid=${customerID}&agingmethod=${agingMethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // const data = res.data.ResponseData;

          if (res.data.ResponseData.length > 0) {
            const mainData = res.data.ResponseData?.map((el) => {
              return {
                ...el,
                OpenBalance: el.OpenBalance ? Number(el.OpenBalance) : 0,
              };
            });
            let grandOpenBalance = mainData.reduce(
              (sum, item) => sum + (item.OpenBalance || 0),
              0
            );
            setTotalOpenBalane(grandOpenBalance);
            setResponseData(mainData);
            setnemultiselect({
              TransactionType: [
                ...new Set(mainData?.map((item) => item?.TransactionType)),
              ],
            });
          } else {
            toastWarn("No Records Found!");
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    address: option.Address1,
    email: option.Email,
    address2: option.Address2,
    City: option.City,
    StateProvince: option.StateProvince,
    Country: option.Country,
    PhoneNumber: option.PhoneNumber,
  }));

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const headerMenu = function () {
    const table = this;
    const menu = [];
    const columns = table.getColumns();

    // Check if we have saved visibility state in localStorage
    const savedVisibility = localStorage.getItem("columnVisibility");
    const visibilityState = savedVisibility ? JSON.parse(savedVisibility) : {};

    for (let column of columns) {
      const field = column.getField();
      const columnDef = column.getDefinition();
      const defaultVisible = columnDef.defaultVisible == true; // Default to true if not specified

      console.log(visibilityState, "visibilityState", defaultVisible);

      // Determine initial visibility:
      // 1. Use saved state if available
      // 2. Fall back to defaultVisible if no saved state
      const shouldBeVisible = visibilityState.hasOwnProperty(field)
        ? visibilityState[field]
        : defaultVisible;

      // Set column visibility
      if (shouldBeVisible) {
        column.show();
      } else {
        column.hide();
      }

      // Create menu item with icon
      const icon = document.createElement("i");
      icon.classList.add("fas");
      icon.classList.add(column.isVisible() ? "fa-check-square" : "fa-square");

      const label = document.createElement("span");
      const title = document.createElement("span");
      title.textContent = " " + columnDef.title;
      label.appendChild(icon);
      label.appendChild(title);

      menu.push({
        label: label,
        action: function (e) {
          e.stopPropagation();

          // Toggle visibility
          const newVisibility = !column.isVisible();
          if (newVisibility) {
            column.show();
            icon.classList.remove("fa-square");
            icon.classList.add("fa-check-square");
          } else {
            column.hide();
            icon.classList.remove("fa-check-square");
            icon.classList.add("fa-square");
          }

          // Update and save visibility state
          visibilityState[field] = newVisibility;
          localStorage.setItem(
            "columnVisibility",
            JSON.stringify(visibilityState)
          );
        },
      });
    }

    return menu;
  };

  const Classiccolumns = [
    {
      title: "Date",
      field: "Date",
      headerFilter: "input",
      defaultVisible: true,
      frozen: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Transaction Type",
      field: "TransactionType",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const data = cell.getRow().getData();
        const link = document.createElement("a");

        link.textContent = data.TransactionType || "";
        link.href = "#";
        link.style.borderRadius = "0.3rem";
        link.style.color = "#343f62";
        link.style.maxWidth = "18ch";
        link.style.fontWeight = "600";
        link.style.cursor = "pointer";
        link.style.textDecoration = "underline";
        link.setAttribute("data-bs-toggle", "modal");
        link.setAttribute("data-bs-target", "#staticBackdrop");

        link.addEventListener("click", (e) => {
          e.preventDefault();
          // assuming handleNavigation is in scope
          handleNavigation(data.ID, data.TransactionType);
        });

        return link;
      },
    },
    {
      title: "Num",
      field: "Num",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const data = cell.getRow().getData();
        const link = document.createElement("a");

        link.textContent = data.Num || "";
        link.href = "#";
        link.style.borderRadius = "0.3rem";
        link.style.color = "#343f62";
        link.style.maxWidth = "18ch";
        link.style.fontWeight = "600";
        link.style.cursor = "pointer";
        link.style.textDecoration = "underline";
        link.setAttribute("data-bs-toggle", "modal");
        link.setAttribute("data-bs-target", "#staticBackdrop");

        link.addEventListener("click", (e) => {
          e.preventDefault();
          handleNavigation(data.ID, data.TransactionType);
        });

        return link;
      },
    },
    {
      title: "Terms",
      field: "Terms",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Due Date",
      field: "DueDate",
      headerFilter: "input",
      defaultVisible: true,
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "OpenBalance",
      headerFilter: "input",
      field: "OpenBalance",
      defaultVisible: true,
      bottomCalc: "sum",
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Account",
      field: "Account",
      headerFilter: "input",
    },
     {
      title: "Amount",
      headerFilter: "input",
      field: "Amount",
      defaultVisible: true,
      bottomCalc: "sum",
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return "0.0";
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return "0.0";
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Billing Address",
      field: "BillingAddress",
      headerFilter: "input",
    },

    {
      title: "Company Name",
      field: "CompanyName",
      headerFilter: "input",
    },
    {
      title: "Create Date",
      field: "CreateDate",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Created By",
      field: "CreatedBy",
      headerFilter: "input",
    },
    {
      title: "Customer Name",
      field: "Customer",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Customer/Vendor Message",
      field: "VendorMessage",
      headerFilter: "input",
    },
    {
      title: "Dilivery Address",
      field: "DiliveryAddress",
      headerFilter: "input",
    },
    {
      title: "Email",
      field: "Email",
      headerFilter: "input",
    },
    {
      title: "Last Modified",
      field: "LastModified",
      headerFilter: "input",
      formatter: function (cell) {
        const value = cell.getValue();
        const dateFormatString = `${dateFormate.toUpperCase()} h:mm A`;

        const formattedDate = moment(value).isValid()
          ? moment(value).format(dateFormatString)
          : "";

        return formattedDate;
      },
    },
    {
      title: "Last Modified By",
      field: "LastModifiedBy",
      headerFilter: "input",
    },
    {
      title: "Memo/Description",
      field: "Description",
      headerFilter: "input",
    },
    {
      title: "Phone",
      field: "Phone",
      headerFilter: "input",
    },
    {
      title: "Shipping Address",
      field: "ShippingAddress",
      headerFilter: "input",
    },
  ];

  const columns = useMemo(() => [
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        const Date = row?.original?.Date;
        if (Date === "0000-00-00" || Date === "" || Date === null) {
          return "";
        }
        return moment(Date).format(`${dateFormate.toUpperCase()}`);
      },
      Footer: () => <Stack>Total:</Stack>,
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      filterSelectOptions: nemultiselect?.TransactionType,
      filterVariant: "multi-select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => (
        <Link
          style={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "600",
            p: "0.3rem",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          type="button"
          onClick={() =>
            handleNavigation(row?.original?.ID, row?.original?.TransactionType)
          }
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          {row?.original?.TransactionType}
        </Link>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => (
        <Link
          style={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "600",
            p: "0.3rem",
            cursor: "pointer",
            textDecoration: "underline",
          }}
          type="button"
          onClick={() =>
            handleNavigation(row?.original?.ID, row?.original?.TransactionType)
          }
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          {row?.original?.Num}
        </Link>
      ),
    },
    {
      header: "Terms",
      accessorKey: "Terms",
      filterFn: "contains",
      size: "130",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) => {
        const dueDate = row.original.DueDate;
        return dueDate
          ? moment(dueDate).format(`${dateFormate.toUpperCase()}`)
          : " ";
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      filterFn: "contains",
      size: "100",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell }) => {
        const total = cell.getValue();
        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total:
            </Box>{" "}
            <Box
              sx={{
                color: "info.main",
                display: "inline",
                fontWeight: "bold",
              }}
            >
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
      Footer: () => (
        <Stack direction="row" justifyContent="flex-end">
          <Box color="warning.main">
            {CurrencySymbols(
              Number(totalOpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </Box>
        </Stack>
      ),

      // AggregatedCell: ({ cell, table }) => {
      //   const groupingColumnId = cell.row.groupingColumnId ?? "";
      //   const originalValue =
      //     cell.row.original?.[groupingColumnId] ??
      //     cell.row.subRows?.[0]?.original?.[groupingColumnId];

      //   // Retrieve the aggregated value
      //   const aggregatedValue = cell.getValue();

      //   // Check if the value is valid and format it
      //   const formattedValue =
      //     typeof aggregatedValue === "number"
      //       ? CurrencySymbols(
      //           Number(aggregatedValue),
      //           { CurrencySymbol },
      //           FractionDigits
      //         )
      //       : // ? aggregatedValue.toLocaleString("en-US", {
      //         //     style: "currency",
      //         //     currency: "USD",
      //         //     minimumFractionDigits: 2,
      //         //     maximumFractionDigits: 2,
      //         //   })
      //         "N/A"; // Fallback for non-numeric values

      //   return (
      //     <>
      //       <Box component="span" sx={{ fontWeight: "bold" }}>
      //         Total for {originalValue ?? "Unknown"}:
      //       </Box>{" "}
      //       <Box
      //         sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
      //       >
      //         {formattedValue}
      //       </Box>
      //     </>
      //   );
      // },
    },
    {
      header: "Account",
      accessorKey: "Account",
    },
    // {
    //   header: "Account type",
    //   accessorKey: "AccountType",
    // },
    {
      header: "Amount",
      accessorKey: "Amount",
      filterFn: "contains",
      size: "110",
      Cell: ({ row }) => {
        return (
          <div>
            {CurrencySymbols(
              Number(row.original.Amount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Billing Address",
      accessorKey: "BillingAddress",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Created Date",
      accessorKey: "CreateDate",
      size: "140",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreateDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Customer Name",
      accessorKey: "Customer",
      filterFn: "contains",
    },
    {
      header: "Customer/Vendor Message",
      accessorKey: "VendorMessage",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Dilivery Address",
      accessorKey: "DiliveryAddress",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Email",
      accessorKey: "Email",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      filterFn: "contains",
      size: "140",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModified;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Last Modified By",
      accessorKey: "LastModifiedBy",
      filterFn: "contains",
      size: "100",
    },
    {
      header: "Memo/Description",
      accessorKey: "Description",
      filterFn: "contains",
      size: "120",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
      filterFn: "contains",
      size: "110",
    },
    {
      header: "Shipping Address",
      accessorKey: "ShippingAddress",
      filterFn: "contains",
      size: "120",
    },
  ]);

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const handleAgingMethodChange = (event) => {
    console.log(event, "radioeventcheck");
  };

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Open Invoices Report</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-2">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                  showasofdate={true}
                />
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Customer
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    isMulti={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                    onChange={(selected) =>
                      setCustomerID(selected?.map((e) => e.value) || [])
                    }
                    value={customerDropDown.filter((b) =>
                      customerID.includes(b.value)
                    )}
                    filterOption={(candidate, input) => {
                      const searchText = input.toLowerCase();
                      const {
                        label,
                        address,
                        PhoneNumber,
                        address2,
                        City,
                        StateProvince,
                        Country,
                      } = candidate.data; // Access additional fields
                      return (
                        label.toLowerCase().includes(searchText) || // Search by name
                        address?.toLowerCase().includes(searchText) || // Search by address
                        PhoneNumber?.toLowerCase().includes(searchText) || // Search by email
                        address2?.toLowerCase().includes(searchText) || // Search by email
                        City?.toLowerCase().includes(searchText) || // Search by email
                        StateProvince?.toLowerCase().includes(searchText) || // Search by email
                        Country?.toLowerCase().includes(searchText) // Search by email
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Aging Method
              </label>
              <div className="row">
                <div className="col-4">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "Current"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "Current" : "ReportDate"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Current
                  </label>
                </div>
                <div className="col-6">
                  <input
                    type="radio"
                    name="day"
                    checked={agingMethod == "ReportDate"}
                    onChange={(e) =>
                      setAgingMethod(
                        e.target.checked ? "ReportDate" : "Current"
                      )
                    }
                  />
                  <label className="col-form-label form-label p-lg-medium ms-2">
                    Report Date
                  </label>
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end mt-2">
              <button
                type="submit"
                className="btn btn-primary"
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center" id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Open Invoices Report</p>
                    <div className="row mb-2">
                      <p>
                        {startdate === "" && enddate === ""
                          ? "All Dates"
                          : "As of " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                        {/* {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )} */}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <div>
                    {ReportViewPermission == true ? (
                      <button
                        className="btn btn-secondary"
                        onClick={() => setClassicView(!classicView)}
                      >
                        {" "}
                        {classicView ? "Classic View" : "Morden View"}
                      </button>
                    ) : (
                      <></>
                    )}
                    {classicView ? (
                      <CommonTabular
                        Data={responseData}
                        columns={Classiccolumns}
                        Groupvalue={["Customer"]}
                        Reportname={"Open Invoices Report"}
                        frozenRowvalue={0}
                        // layout={"fitDataFill"}
                        Onrefresh={() => apicall()}
                      />
                    ) : (
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Open Invoices Report"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={["Customer"]}
                        enableExpandAll={true}
                        enableExpanding={true}
                        expanded={true}
                        enableRowSelection={false}
                        columnsVisibility={{
                          LastModified: false,
                          CreateDate: false,
                          LastModifiedBy: false,
                          CreatedBy: false,
                          Phone: false,
                          CompanyName: false,
                          BillingAddress: false,
                          Email: false,
                          ShippingAddress: false,
                          DiliveryAddress: false,
                          Description: false,
                          VendorMessage: false,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OpenInvoices;
